import Button from '@mui/material/Button'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported  */
interface CaleoSecondaryButtonProps {
  /** Id of the button. */
  id?: string
  /** Action to perform on button click. */
  clickAction: (e: React.MouseEvent<HTMLButtonElement>) => void
  /** Whether the button is valid. */
  valid: boolean
  /** Label of the button. */
  label: string
  /** Test id of the button. */
  testId?: string
}

/**
 * Caleo secondary button.
 *
 * @returns Caleo secondary button component.
 * @notExported
 * @category Buttons
 */
const CaleoSecondaryButton: React.FC<CaleoSecondaryButtonProps> = ({ id, clickAction, valid, label, testId }) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-secondary', id, label, testId })

  return (
    <Button
      id={id ? id : 'search'}
      data-testid={resolvedTestId}
      type="button"
      color="secondary"
      variant="contained"
      disabled={!valid}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => clickAction(e)}
    >
      {label}
    </Button>
  )
}

export default CaleoSecondaryButton
